import { apiClient } from '@/lib/api/api-client';
import type {
  Organization,
  OrganizationMember,
  OrganizationLOB,
  CreateOrganizationInput,
  UpdateOrganizationInput,
  AddMemberInput,
  UpdateMemberInput,
} from '../types/organization.types';

const BASE = '/api/organizations';

export const organizationService = {
  list: () => apiClient.get<Organization[]>(BASE),
  get: (id: string) => apiClient.get<Organization>(`${BASE}/${id}`),
  create: (data: CreateOrganizationInput) => apiClient.post<Organization>(BASE, data),
  update: (id: string, data: UpdateOrganizationInput) =>
    apiClient.patch<Organization>(`${BASE}/${id}`, data),
  delete: (id: string) => apiClient.delete<{ message: string }>(`${BASE}/${id}`),

  listMembers: (id: string) => apiClient.get<OrganizationMember[]>(`${BASE}/${id}/members`),
  addMember: (id: string, data: AddMemberInput) =>
    apiClient.post<OrganizationMember>(`${BASE}/${id}/members`, data),
  updateMember: (id: string, userId: string, data: UpdateMemberInput) =>
    apiClient.patch<OrganizationMember>(`${BASE}/${id}/members/${userId}`, data),
  removeMember: (id: string, userId: string) =>
    apiClient.delete<{ message: string }>(`${BASE}/${id}/members/${userId}`),

  listLobs: (id: string) => apiClient.get<OrganizationLOB[]>(`${BASE}/${id}/lobs`),
  setLobs: (id: string, lobIds: string[]) =>
    apiClient.put<OrganizationLOB[]>(`${BASE}/${id}/lobs`, { lobIds }),
};
